import { IGridConfig } from './typings';

const config: IGridConfig = {
  direction: 'row',
  sections: { items: [] },
};

export default config;
